import React from "react";
import { useSelector } from "react-redux";
import AccountLayout from "../../blocs/AccountLayout";
import PaymentMethods from "../../components/PaymentMethods";
import Calendar from "../../components/Calendar";

const PaymentInfo = () => {
  const { isAuthenticated } = useSelector((state) => state.user);

  if (!isAuthenticated) {
    return (
      <div>
        Veuillez vous connecter pour accéder à vos informations de paiement.
      </div>
    );
  }

  return (
    <AccountLayout bgColor={"bgColor"}>
      <PaymentMethods />
    </AccountLayout>
  );
};

export default PaymentInfo;
